import { MDSTextVariant } from "@/mds/components/text/text.types";

export const mdsFontSizesValue = {
  xxxxsmall: "10px",
  xxxsmall: "11px",
  xxsmall: "12px",
  xsmall: "13px",
  small: "14px",
  smedium: "15px",
  medium: "16px",
  large: "20px",
  xlarge: "24px",
  xxlarge: "30px",

  // Updated text styles
  [MDSTextVariant.HeaderXl]: "36px",
  [MDSTextVariant.HeaderL]: "28px",
  [MDSTextVariant.HeaderM]: "22px",
  [MDSTextVariant.HeaderS]: "20px",
  [MDSTextVariant.TextM]: "18px",
  [MDSTextVariant.TextSm]: "14px",
  [MDSTextVariant.TextS]: "14px",
  [MDSTextVariant.TextSmd]: "14px",
  [MDSTextVariant.TextXs]: "12px",
  [MDSTextVariant.ParagraphSm]: "15px",
  [MDSTextVariant.ParagraphS]: "14px",
  [MDSTextVariant.CodeSm]: "15px",
};

export const mdsLineHeightsValue = {
  xxxsmall: "12px",
  xxsmall: "14px",
  xsmall: "16px",
  small: "20px",
  smedium: "22px",
  medium: "24px",
  large: "28px",
  xlarge: "32px",
  xxlarge: "40px",

  // Updated line heights
  [MDSTextVariant.HeaderXl]: "40px",
  [MDSTextVariant.HeaderL]: "36px",
  [MDSTextVariant.HeaderM]: "30px",
  [MDSTextVariant.HeaderS]: "28px",
  [MDSTextVariant.TextM]: "20px",
  [MDSTextVariant.TextSm]: "16px",
  [MDSTextVariant.TextS]: "16px",
  [MDSTextVariant.TextSmd]: "16px",
  [MDSTextVariant.TextXs]: "16px",
  [MDSTextVariant.ParagraphSm]: "22px",
  [MDSTextVariant.ParagraphS]: "20px",
  [MDSTextVariant.CodeSm]: "22px",
};

export const mdsLineSpacingsValue = {
  medium: "-0.16px",
  mediumLarge: "-0.4px",
  large: "-0.48px",

  // Updated line spacings
  [MDSTextVariant.HeaderXl]: "-0.01em",
  [MDSTextVariant.HeaderL]: "-0.28px",
  [MDSTextVariant.HeaderM]: "-0.01em",
  [MDSTextVariant.HeaderS]: "-0.01em",
  [MDSTextVariant.TextM]: "normal",
  [MDSTextVariant.TextSm]: "normal",
  [MDSTextVariant.TextS]: "normal",
  [MDSTextVariant.TextSmd]: "normal",
  [MDSTextVariant.TextXs]: "normal",
  [MDSTextVariant.ParagraphSm]: "normal",
  [MDSTextVariant.ParagraphS]: "normal",
  [MDSTextVariant.CodeSm]: "normal",
};

export const mdsFontWeightsValue = {
  regular: 400,
  medium: 500,
  smedium: 550,
  semiBold: 600,
  bold: 700,
  extrabold: 800,
};

export const mdsSpacingsValue = {
  xxs: "2px",
  xs: "4px",
  xsPlus: "6px",
  sm: "8px",
  smPlus: "10px",
  smd: "12px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "40px",

  // UPDATED SPACINGS
  ["0"]: "0px",
  ["0.5"]: "2px",
  ["1"]: "4px",
  ["2"]: "8px",
  ["3"]: "12px",
  ["4"]: "16px",
  ["5"]: "20px",
  ["6"]: "24px",
  ["7"]: "28px",
  ["8"]: "32px",
  ["9"]: "36px",
  ["10"]: "40px",
};

export type MDSFontSizes = typeof mdsFontSizesValue;
export type MDSLineHeights = typeof mdsLineHeightsValue;
export type MDSLineSpacings = typeof mdsLineSpacingsValue;
export type MDSFontWeights = typeof mdsFontWeightsValue;
export type MDSSpacings = typeof mdsSpacingsValue;

// Function versions for backward compatibility
export const mdsFontSizes = () => mdsFontSizesValue;
export const mdsLineHeights = () => mdsLineHeightsValue;
export const mdsLineSpacings = () => mdsLineSpacingsValue;
export const mdsFontWeights = () => mdsFontWeightsValue;
export const mdsSpacings = () => mdsSpacingsValue;
